import { render, staticRenderFns } from "./CoiCouponManage.vue?vue&type=template&id=5b3ac562&scoped=true"
import script from "./CoiCouponManage.vue?vue&type=script&lang=js"
export * from "./CoiCouponManage.vue?vue&type=script&lang=js"
import style0 from "./CoiCouponManage.vue?vue&type=style&index=0&id=5b3ac562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ac562",
  null
  
)

export default component.exports